import Button from "@material-ui/core/Button";
import MuiCard from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import React from "react";
import { Link } from "react-router-dom";

const styles = (theme: Theme) =>
  createStyles({
    cardActions: {
      justifyContent: "flex-end",
      paddingBottom: theme.spacing(2),
    },
  });

interface CardProps extends WithStyles<typeof styles> {
  title: string;
  description: string;
  buttonLabel: string;
  url: string;
  className?: string;
}

export const CardComponent = (props: CardProps) => {
  const { title, description, buttonLabel, url, classes, className } = props;

  return (
    <MuiCard className={className}>
      <CardContent>
        <Typography gutterBottom={true} variant="h5">
          {title}
        </Typography>
        <Typography component="p">{description}</Typography>
      </CardContent>
      <CardActions className={classes.cardActions}>
        <Button color="primary" variant="contained" component={Link} to={url}>
          {buttonLabel}
        </Button>
      </CardActions>
    </MuiCard>
  );
};

export const Card = withStyles(styles)(CardComponent);
